import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class SetIgVersionModalActions {
  confirm: (event: ButtonTriggerEvent) => void;
  cancel?: () => void;
}

export class SetIgVersionModalData {
  account: Account;
  constructor(account?) {
    this.account = account;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.ig.version/set.ig.version.modal.provider.ts